import { pageHeaderHeight, pageTitleHeight, tableToolbarHeight, tabListHeight } from '@/constants'
import { useLayout } from '@/providers'

type Options = {
	pageTitle?: boolean
	tabList?: boolean
	tableToolbar?: boolean
	extra?: string[]
}

/**
 * Calculates the available page height below the app's global chrome (app bar,
 * announcement banner, and the new page header when enabled) and any page-specific
 * chrome the caller indicates is present above their content.
 *
 * @example
 * const height = usePageHeight({ pageTitle: true, tableToolbar: true })
 */
export default function usePageHeight({
	pageTitle = false,
	tabList = false,
	tableToolbar = false,
	extra = [],
}: Options = {}): string {
	const { appBarHeight, announcementHeight } = useLayout()

	const heights = [
		appBarHeight,
		announcementHeight,
		...[pageHeaderHeight],
		...(pageTitle ? [pageTitleHeight] : []),
		...(tabList ? [tabListHeight] : []),
		...(tableToolbar ? [tableToolbarHeight] : []),
		...extra,
	]

	return `calc(100vh - ${heights.join(' - ')})`
}
